module.exports = __webpack_public_path__ + "img/lzd_tiktaqto_0.561d8318.png";